// extracted by mini-css-extract-plugin
export default {"container":"-XYAh","mobileContainer":"_0ECyO"};